import {
    CardFragment,
    HighlightFragment,
    ReadMoreQuery,
    SearchImage,
    SearchPageQuery,
    TileTransformFragment,
} from '../generated/graphql';
import { Maybe } from '@oberoninternal/travelbase-ds/entities/Maybe';
import { IntlFormatters } from 'react-intl';

// craft gives us a different type when we're working with search results.
// this means we have to 'fake' some fragments and convert them first.

const searchImageToTransform = (image: Maybe<SearchImage>): TileTransformFragment[] =>
    image
        ? [
              {
                  ...image,
                  __typename: 'library_Asset',
                  placeholderUrl: image.placeholderUrl,
                  srcset: image.srcset,
                  srcsetWebp: image.srcsetWebp,
                  extension: image.extension ?? '',
              },
          ]
        : [];

export const searchHitToCard = (
    globalSearch: SearchPageQuery['globalSearch'],
    formatDate: IntlFormatters['formatDate']
): CardFragment[] =>
    globalSearch?.hits
        ?.map((hit): CardFragment | null => {
            if (!hit) {
                return null;
            }
            const { image } = hit;
            return {
                __typename: hit.type === 'articles' ? 'article_Entry' : 'page_Entry',
                heroImage: searchImageToTransform(image),
                title: hit.title,
                postDate:
                    hit.type === 'articles' && hit.postDate
                        ? formatDate(hit.postDate, {
                              // @ts-ignore
                              dateStyle: 'long',
                          })
                        : undefined,
                uri: hit.uri,
            };
        })
        .filter((hit): hit is NonNullable<typeof hit> => !!hit) ?? [];

export const searchHitToHighlight = (hits: ReadMoreQuery['search']): HighlightFragment[] =>
    hits
        ?.map((hit): HighlightFragment | null => {
            if (!hit) {
                return null;
            }
            const { image } = hit;
            const images = searchImageToTransform(image);

            if (hit.type === 'pages') {
                return {
                    __typename: 'page_Entry',
                    heroImage: images,
                    title: hit.title,
                    uri: hit.uri,
                };
            }
            return {
                __typename: 'article_Entry',
                newsHeroImage: images,
                title: hit.title,
                uri: hit.uri,
            };
        })
        .filter((hit): hit is NonNullable<typeof hit> => !!hit) ?? [];
